import { QuoteDetailDto } from "@/types/dto/quote-detail-dto";
import { atom } from "recoil";

const PREVIEW_STORAGE_KEY = "quote_preview";

const getInitialState = (): QuoteDetailDto | undefined => {
  if (typeof window === "undefined") return undefined;

  const savedPreview = localStorage.getItem(PREVIEW_STORAGE_KEY);
  if (!savedPreview) return undefined;

  try {
    return JSON.parse(savedPreview);
  } catch {
    return undefined;
  }
};

export const previewState = atom<QuoteDetailDto | undefined>({
  key: "previewState",
  default: getInitialState(),
  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        if (typeof window === "undefined") return;

        if (newValue === undefined) {
          localStorage.removeItem(PREVIEW_STORAGE_KEY);
        } else {
          localStorage.setItem(PREVIEW_STORAGE_KEY, JSON.stringify(newValue));
        }
      });
    },
  ],
});
